import { Pipe, PipeTransform } from '@angular/core';
import { BlobUrls } from '../core/config';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'download'
})

export class DownloadPipe implements PipeTransform {
  /**
   *
   */
  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}
  
  downloadPath: string = BlobUrls.Download + '/';

 transform(url: string, defaultUrl: string): string {
  
  if (!url) return defaultUrl;
  
  const isFullUrl = /^(https?:)?\/\//i.test(url);

  if (isFullUrl) return url; 

  return this.downloadPath + url;
  }

}
